import { render, staticRenderFns } from "./Historiasecciones.vue?vue&type=template&id=774dbdad"
import script from "./Historiasecciones.vue?vue&type=script&lang=js"
export * from "./Historiasecciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports